import { render, staticRenderFns } from "./SaldosClientesFiltrados.vue?vue&type=template&id=8d857752&"
import script from "./SaldosClientesFiltrados.vue?vue&type=script&lang=js&"
export * from "./SaldosClientesFiltrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports